import {WglRenderer} from '../webgl_renderer';

// Very first launch
export function WglRenderer_launch(this: WglRenderer) {}
